import React, { useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { useDispatch} from 'react-redux';
import { useHistory } from 'react-router-dom';
import { paymentMethodCreate, paymentClientSecret} from 'redux/actions/payment';

import AlertModal from 'web/components/AlertModal';
import Button from 'web/components/Button';
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';

const ACHForm = ({ props, callBackFetchApi, callBackModal }) => {
    const { isValid, dirty } = props;
    const stripe = useStripe();


    const dispatch = useDispatch();
    let history = useHistory();
    const [alertType, setAlertType] = useState();

    const token = localStorage.getItem("token");
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('/');
    const toggleModal = () => setModal(!modal);
    let title = '';

    const submitHandler = async (props) => {
        if (props.values.accountHolderName !== '' && props.values.bankRouting !== '' && props.values.bankAccount !== '') {
            paymentClientSecretApi(props)
        }
    };
    const paymentClientSecretApi = async (props) => {
        let response = await dispatch(paymentClientSecret(token));
        if (response.status === "FAILURE") {
            setModalContent(response.message);
            setModalLink('');
            toggleModal();
        } else {
            confirmBankAccountPayment(response, props)
        }
    }
    const confirmBankAccountPayment = async (clientSecret, props) => {
        const result = stripe.confirmUsBankAccountSetup(
            clientSecret,
            {
                payment_method: {
                    us_bank_account: {
                        routing_number: props.values.bankRouting,
                        account_number: props.values.bankAccount,
                        account_holder_type: 'individual',
                    },
                    billing_details: {
                        name: props.values.accountHolderName,
                        email: localStorage.getItem('adminEmail'),
                    },
                },
            }
        ).then(function (result) {
            if (result.error) {
                if (result.error.message === "Invalid test mode account number (323232323232323) used. See a list of the valid account numbers at https://stripe.com/docs/payments/ach-debit/accept-a-payment#test-account-numbers.") {
                    setModalContent("Please enter a valid Bank Account number.");
                } else if (result.error.message === 'Invalid test mode account number (0001111111232) used. See a list of the valid account numbers at') {
                    setModalContent("Please enter a valid Bank Account number.");
                }
                else {
                    setModalContent(result.error.message);
                }

                setModalLink('');
                toggleModal();
            } else {
                paymentMethodCreateApi(result, props)
            }
        });
    }
    const paymentMethodCreateApi = async (result) => {
        let data = {
            forBuying: true,
            paymentMethodId: result.setupIntent.payment_method,
            name: props.values.accountHolderName,
            clientSecret: result.setupIntent.client_secret
        }

        let response = await dispatch(paymentMethodCreate(data, token));

        if (response.status === "SUCCESS") {
            setAlertType('cardValidated')
            setModalContent('ACH details added successfully.');
            setModalLink('');
            toggleModal();
        } else {
            if (response.message === "Unauthorized (Invalid token)") {
                history.push('/sign-in');
                window.location.reload(false);
            } else {
                setModalContent(response.message);
                setModalLink('');
                toggleModal();
            }
        }
    }
    return (<>

        <>
            <div><p>Account Holder Name<span class="star">*</span></p>
                <div>
                    <TextInput
                        name='accountHolderName'
                        inputType="text"
                        placeholder="Account Holder Name"
                    />
                </div>
            </div>
            <div><p>Bank Account Number<span class="star">*</span></p>
                <div>
                    <NumberInput
                        name='bankAccount'
                        placeholder='Account Number'
                        maxLength='20'
                    />
                </div>
            </div>
            <div><p>Bank Routing Number<span class="star">*</span></p>
                <div>
                    <NumberInput
                        name='bankRouting'
                        placeholder='Routing Number'
                        maxLength='20'
                    />
                </div>
            </div>
            <Button
                type='app-green-button'
                disabled={!(isValid && dirty)}
                handleClick={() => {
                    if (props.values.accountHolderName === '' || props.values.accountHolderName === undefined) {
                        setModalContent('Please enter account holder name.');
                        setModalLink('');
                        toggleModal();
                    } else if (props.values.bankAccount === '' || props.values.bankAccount === undefined) {
                        setModalContent('Please enter bank account number.');
                        setModalLink('');
                        toggleModal();
                    }
                    else if (props.values.bankRouting === '' || props.values.bankRouting === undefined) {
                        setModalContent('Please enter bank routing number.');
                        setModalLink('');
                        toggleModal();
                    } else {
                        submitHandler(props);
                    }
                }}
            >
                Submit
            </Button>

            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=""
                content={modalContent}
                alertType={alertType}
                callBackAlert={(val) => {
                    if (val === 'cardValidated') {
                        callBackFetchApi()
                    }

                }}
                link={modalLink}
            />
        </>

    </>
    );
};

export default ACHForm;
